<template>
  <b-modal id="modal-informacoes-unidade" title="Informações da Unidade" hide-footer>
    <div v-if="unidade">
      <p><strong>Nome:</strong> {{ unidade.nome }}</p>
      <p><strong>Email:</strong> {{ unidade.email || 'Não informado' }}</p>
      <p><strong>Telefone:</strong> {{ unidade.telefone || 'Não informado' }}</p>
      <p><strong>Endereço:</strong> {{ unidade.endereco }}</p>
    </div>
    <div v-else class="text-center">
      <b-spinner small />
      <p>Carregando informações...</p>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "ModalInformacoesUnidade",
  props: {
    unidade: Object
  }
};
</script>
